'use strict';

bbw.shared.LayoutCtrl = ngtk.controller.Base.extend({

    _init: function() {
        this.$scope.mobileGlobalMenu = {
            visible: false
        };
    },

    showMobileGlobalMenu: function() {
        this._setMobileGlobalMenuVisibility(true);
    },

    hideMobileGlobalMenu: function() {
        this._setMobileGlobalMenuVisibility(false);
    },

    toggleMobileGlobalMenu: function() {
        this._setMobileGlobalMenuVisibility();
    },

    _setMobileGlobalMenuVisibility: function(value) {
        if (angular.isUndefined(value)) {
            value = !this.$scope.mobileGlobalMenu.visible
        } else {
            value = !!value;
        }
        this.$scope.mobileGlobalMenu.visible = value;
    }

});
